import React from 'react';

export interface PriceFlagProps {
}

const PriceFlag : React.FC<PriceFlagProps> = ({
  children,
}) => (
  <div className="pricing price-flag price-flag-lg price-flag-decent price-flag-left">
    {children}
  </div>
);

export default PriceFlag;
